import { Helmet } from 'react-helmet';
import { useMessages2 } from '../hooks/useLanguage'
import { DEFAULT_TITLE_SUFFIX } from '../messages';

export function PageMetadata({ pageTitle } : {
    pageTitle: string
}) {

    const { messages } = useMessages2();

    return <Helmet>
        <title>{ pageTitle } - { messages?.intro_title ?? DEFAULT_TITLE_SUFFIX }</title>
    </Helmet>

}